import React, { useContext, useEffect } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { BannersCarroselProps } from 'types/BannersCarroselProps';
import SimpleInput from 'components/SimpleInput';
import InputImgBigger from 'components/InputImgBigger';
import { ImgSavedProps } from 'types/ImgSavedProps';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { addBannerReq, editBannerReq } from './reqs';

interface FormBannerCarouselProps {
	isOpenForm: boolean;
	setIsOpenForm: React.Dispatch<React.SetStateAction<boolean>>;
	bannerToEdit: BannersCarroselProps | null;
	setBannerToEdit: React.Dispatch<
		React.SetStateAction<BannersCarroselProps | null>
	>;
	setListBanners: React.Dispatch<React.SetStateAction<BannersCarroselProps[]>>;
	listBanners: BannersCarroselProps[];
}

const initialStateForm: BannersCarroselProps = {
	id: '',
	name: '',
	urlBanner: '',
	position: 0
};

export default function FormBannerCarousel({
	isOpenForm,
	setIsOpenForm,
	bannerToEdit,
	listBanners,
	setBannerToEdit,
	setListBanners
}: FormBannerCarouselProps) {
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [dataForm, setDataForm] = React.useState<BannersCarroselProps>(
		bannerToEdit
			? bannerToEdit
			: {
					...initialStateForm,
					position: listBanners[listBanners.length - 1]?.position + 1 || 1
				}
	);

	function resetStatesComp() {
		setIsOpenForm(false);
		setDataForm(initialStateForm);
		setBannerToEdit(null);
	}

	function verifyIfCanSave() {
		if (dataForm.name === '') {
			handleNotify('Preenha o nome', 'error');
			return false;
		}

		if (dataForm.urlBanner === '') {
			handleNotify('Insira a logo', 'error');
			return false;
		}

		return true;
	}

	async function saveBanner() {
		const canSave = verifyIfCanSave();

		if (!canSave) {
			handleNotify('Algum erro aconteceu', 'error');
			return;
		}

		const { isSuccess, bannerSaved } = await addBannerReq(
			dataForm,
			setIsOpenLoad,
			setMessage,
			handleNotify
		);

		if (isSuccess && bannerSaved) {
			setListBanners((list) => [...list, { ...bannerSaved }]);
			resetStatesComp();
		} else {
			handleNotify('Erro ao salvar banner, tente novamente', 'error');
		}
	}

	async function editBanner() {
		const canSave = verifyIfCanSave();

		if (!canSave && listBanners.length === 0) {
			handleNotify('Algum erro aconteceu', 'error');
			return;
		}

		if (bannerToEdit) {
			const { isSuccess } = await editBannerReq(
				bannerToEdit,
				dataForm,
				setIsOpenLoad,
				setMessage,
				handleNotify
			);

			if (isSuccess) {
				const newList = listBanners.map((item) => {
					if (item.id === bannerToEdit?.id) {
						return { ...dataForm };
					} else {
						return item;
					}
				});

				setListBanners(newList);
				resetStatesComp();
			}
		}
	}

	useEffect(() => {
		return () => {
			resetStatesComp();
		};
	}, []);

	return (
		<Modal
			isOpenProps={isOpenForm}
			setIsOpenModal={() => {
				setIsOpenForm((value) => !value);
				resetStatesComp();
			}}
			title={'Formulário banner'}
			buttonClose={false}
		>
			<S.container>
				<S.contentForm>
					<SimpleInput
						label="Nome"
						initialValue={dataForm.name}
						getValue={(value: string) => {
							setDataForm((obj) => ({ ...obj, name: value }));
						}}
					/>

					<InputImgBigger
						idImagem="bannerImg"
						initialImage={dataForm.urlBanner}
						getImage={(value: ImgSavedProps) => {
							setDataForm((obj) => ({
								...obj,
								urlBanner: value?.url || ''
							}));
						}}
						label="Banner"
					/>
				</S.contentForm>

				<S.containerBtns>
					<S.cancel
						data-testid="cancelBtn"
						onClick={() => {
							resetStatesComp();
						}}
					>
						Cancelar
					</S.cancel>
					<S.save
						data-testid="saveBtn"
						onClick={async () => {
							if (bannerToEdit) {
								await editBanner();
							} else {
								await saveBanner();
							}
						}}
					>
						Salvar
					</S.save>
				</S.containerBtns>
			</S.container>
		</Modal>
	);
}
